import DOMPurify from "dompurify";

function Button(props) {
  let classNames =
    (props.className ?? "") +
    " tw-inline-flex tw-items-center tw-justify-center tw-px-4 tw-rounded-full tw-transition-colors";
  let innerClassNames =
    "tw-uppercase tw-font-black tw-font-condensed tw-leading-4 md:tw-leading-3";

  const color = props.color ?? "black";
  const type = props.type ?? "fill";
  const size = props.size ?? "large";

  if (type === "fill") {
    switch (color) {
      case "black":
        classNames += " tw-bg-black hover:tw-bg-orange tw-text-white";

        break;
      case "orange":
        classNames += " tw-bg-orange hover:tw-bg-orange-dark tw-text-white";

        break;
      case "teal":
      default:
        classNames += " tw-bg-teal hover:tw-bg-teal-dark tw-text-white";

        break;
    }
  } else if (type === "outline") {
    switch (color) {
      case "white":
        classNames +=
          " tw-border tw-border-white tw-text-white hover:tw-border-orange hover:tw-text-orange";

        break;
      case "black":
      default:
        classNames +=
          " tw-border tw-border-black tw-text-black hover:tw-bg-black hover:tw-text-white";

        break;
    }
  } else if (type === "text") {
    switch (color) {
      case "orange":
      default:
        classNames += " tw-underline tw-text-orange hover:tw-text-teal";

        break;
    }
  }

  switch (size) {
    case "tiny":
      classNames += " tw-h-5";
      innerClassNames += " tw-text-xs";

      break;
    case "small":
      classNames += " tw-h-8";
      innerClassNames += " tw-text-sm lg:tw-text-base";

      break;
    case "medium":
      classNames += " tw-h-10";
      innerClassNames += " tw-text-md lg:tw-px-9";

      break;
    case "cta":
      classNames += " tw-h-10 md:tw-h-12";
      innerClassNames += " tw-text-lg md:tw-text-xl";

      break;
    case "large":
    default:
      classNames += " tw-h-10";
      innerClassNames += " tw-text-base md:tw-text-lg lg:tw-px-9";

      break;
  }

  classNames += " " + props.className;

  if(props.title == '') return <></>;
  
  return (
    <>
      {props.href && (
        <a className={classNames} target={props.target} href={props.href}>
          <span
            className={innerClassNames}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.title),
            }}
          />
        </a>
      )}
      {!props.href && props.onClick && (
        <button className={classNames} onClick={props.onClick}>
          <span
            className={innerClassNames}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.title),
            }}
          />
        </button>
      )}
      {!props.href && !props.onClick && (
        <div className={classNames}>
          <span
            className={innerClassNames}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.title),
            }}
            target={props.target}
          />
        </div>
      )}
    </>
  );
}

export default Button;
